import { Component, Input } from '@angular/core';
import { HeroSliderService } from '../../../pages/start/services/hero-slider.service';
import { CommonModule } from '@angular/common';
import { advantages, group, IconComponent, newAlpy, provideIcons, storno } from '../../icons';
import { AlpitranslatePipe } from '../../../core/pipes/alpitranslate.pipe';

@Component({
  selector: 'app-hero-slider-nav',
  templateUrl: './hero-slider-nav.component.html',
  styleUrls: ['./hero-slider-nav.component.scss'],
  imports: [CommonModule, IconComponent, AlpitranslatePipe],
  providers: [
    provideIcons({
      advantages,
      storno,
      newAlpy,
      group
    })
  ]
})
export class HeroSliderNavComponent {
  @Input() pageType: string;

  constructor(public heroSliderService: HeroSliderService) {}

  updateActiveSlide(index: number) {
    this.heroSliderService.updateActiveSlide(index);
  }
}
